export default {
	components: {},
	data() {
		return {
			eisCodeForm: {
				eisCode: '',
			}
		}
	},
	methods: {
		checkEisCode() {
			this.$emit('onSubmit', this.eisCodeForm.eisCode);
		}
	},
}